module.exports = __webpack_public_path__ + "static/img/cp4.b8d7ca74.png";